export const markdownDocuments = [
  {
    id: "api_docs",
    title: "API",
    description:
      "Overview of the AI Agent API, including authentication, endpoints, and request/response formats.",
    component: "HelpModal",
    props: {
      doc: "api_docs",
    },
  },
  {
    id: "ensuring_quality",
    title: "Ensuring Quality and Safety in AI Patient Interventions",
    description:
      "Explore the three-phase process ensuring top quality, safety, and accuracy, reducing AI hallucination risks.",
    component: "HelpModal",
    props: {
      doc: "ensuring_quality",
    },
  },
  {
    id: "release_notes",
    title: "Release Notes",
    description: "View the release notes for the current version of the system",
    component: "HelpModal",
    props: {
      doc: "release_notes",
    },
  },
  {
    id: "request_access",
    title: "Requesting Access",
    description: "How to request access to the system",
    component: "HelpModal",
    props: {
      doc: "request_access",
    },
  },
  {
    id: "script_rules",
    title: "Script Rules",
    description:
      "Outlines the rules and guidelines for creating and using scripts in the pre-processing, primary, and post-processing stages.",
    component: "HelpModal",
    props: {
      doc: "script_rules",
    },
  },
  {
    id: "special_commands",
    title: "Special Commands",
    description:
      "Special commands that can be used within conversation prompts.",
    component: "HelpModal",
    props: {
      doc: "special_commands",
    },
  },
  {
    id: "Terminology",
    title: "Terminology",
    description: "Definitions of terms used in the system",
    component: "HelpModal",
    props: {
      doc: "terminology",
    },
  }
];